import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Filters from './Filters';
import Modal from 'react-modal';
import arrowIcon from './images/arrow-icon.svg';
import closeIcon from './images/close-icon.svg';
import 'rheostat/css/rheostat.css';
import './Filters.css';

// setAppElement throws an error in tests "react-modal: No elements were found for selector #app."
/* istanbul ignore if */
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

class FiltersModal extends Component {
    state = {
        modalIsOpen: false,
    }

    toggleModal = () => this.setState(prevState => ({
        modalIsOpen: !prevState.modalIsOpen,
    }))

    render() {
        const { filters, filtersOff, maxAvailSqFt, options, handleChange, handleClear } = this.props;

        return (
            <div className="filters-modal-wrapper">
                <button onClick={this.toggleModal} className={`link filter-icon ${filtersOff ? '' : 'active'}`}>
                    <svg id="filter-icon" className="icon" data-name="filter-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.02 8.29">
                        <title>filter-icon</title>
                        <path d="M128.26,264.52a.24.24,0,0,1,.24.24v4.12a.24.24,0,0,1-.48,0v-4.12A.24.24,0,0,1,128.26,264.52Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M122.27,271.18a.24.24,0,0,1,.24.24v1a.24.24,0,0,1-.48,0v-1A.24.24,0,0,1,122.27,271.18Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M125.27,264.4a.23.23,0,0,1,.23.23v.64a.23.23,0,0,1-.23.24.24.24,0,0,1-.24-.24v-.64A.23.23,0,0,1,125.27,264.4Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M125.27,267.59a.23.23,0,0,1,.23.24v4.61a.23.23,0,0,1-.23.24.24.24,0,0,1-.24-.24v-4.61A.24.24,0,0,1,125.27,267.59Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M122.27,264.52a.24.24,0,0,1,.24.24v3.71a.24.24,0,0,1-.48,0v-3.71A.24.24,0,0,1,122.27,264.52Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M128.23,268.67a1.51,1.51,0,1,1-1.51,1.51A1.51,1.51,0,0,1,128.23,268.67Zm0,2.54a1,1,0,1,0-1-1A1,1,0,0,0,128.23,271.21Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M125.23,265.05a1.51,1.51,0,1,1-1.5,1.5A1.51,1.51,0,0,1,125.23,265.05Zm0,2.53a1,1,0,1,0-1-1A1,1,0,0,0,125.23,267.58Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M122.22,268.39a1.51,1.51,0,1,1-1.5,1.5A1.51,1.51,0,0,1,122.22,268.39Zm0,2.54a1,1,0,1,0-1-1A1,1,0,0,0,122.22,270.93Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M128.26,264.52a.24.24,0,0,1,.24.24v4.12a.24.24,0,0,1-.48,0v-4.12A.24.24,0,0,1,128.26,264.52Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M128.28,271.39a.22.22,0,0,1,.23.21v.88a.22.22,0,0,1-.23.21.23.23,0,0,1-.24-.21v-.88A.23.23,0,0,1,128.28,271.39Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M122.27,271.18a.24.24,0,0,1,.24.24v1a.24.24,0,0,1-.48,0v-1A.24.24,0,0,1,122.27,271.18Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M125.27,264.4a.23.23,0,0,1,.23.23v.64a.23.23,0,0,1-.23.24.24.24,0,0,1-.24-.24v-.64A.23.23,0,0,1,125.27,264.4Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M125.27,267.59a.23.23,0,0,1,.23.24v4.61a.23.23,0,0,1-.23.24.24.24,0,0,1-.24-.24v-4.61A.24.24,0,0,1,125.27,267.59Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                        <path d="M122.27,264.52a.24.24,0,0,1,.24.24v3.71a.24.24,0,0,1-.48,0v-3.71A.24.24,0,0,1,122.27,264.52Z" transform="translate(-120.72 -264.4)" fill="#c7c8c9" />
                    </svg>
                    <span>FILTER</span>
                </button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.toggleModal}
                    contentLabel="Modal"
                    className="office-filters-modal"
                    overlayClassName="Overlay"
                >
                    <div className="button-wrapper">
                        <div className="columns is-marginless is-mobile">
                            <button onClick={this.toggleModal} className="column is-one-third icon-wrapper close-button">
                                <img className="icon" src={arrowIcon} alt={arrowIcon} />
                                <div className="button-text">{filtersOff ? 'CLOSE' : 'APPLY'}</div>
                            </button>
                            {!filtersOff && <button onClick={handleClear} className="column is-one-third is-offset-one-third icon-wrapper clear-button">
                                <img className="icon" src={closeIcon} alt={closeIcon} />
                                <div className="button-text">CLEAR</div>
                            </button>}
                        </div>
                    </div>
                    <Filters
                        options={options}
                        filters={filters}
                        handleChange={handleChange}
                        handleClear={handleClear}
                        maxAvailSqFt={maxAvailSqFt}
                    />
                </Modal>
            </div>
        );
    }
}

FiltersModal.propTypes = {
    filters: PropTypes.object.isRequired,
    filtersOff: PropTypes.bool.isRequired,
    options: PropTypes.object.isRequired,
    maxAvailSqFt: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired, // FIXME: Might end up removing this because of a future refactor
};

export default FiltersModal;
